import Ext from "Ext";
import SelectionHelper from "./at_selection_helper";

const HierarchySelectorSelectionHelper = Ext.extend(SelectionHelper, {

    wrapTextByTitleSpans: function(text, dropdownButtonId, isFirstLevel) {
        var result = '<span onmouseover="Ext.getCmp(\'' + dropdownButtonId + '\').showInnerTooltip(this, ' + isFirstLevel + ')" ' +
                     'onmouseout="Ext.getCmp(\'' + dropdownButtonId + '\').hideTooltip(this)">';
        result += text;
        result += '</span>';
        return result;
    },

    getOneOfEntitiesList: function(selection) {
        var firstLevelPresent = selection.getFirstLevel().length > 0;
        var secondLevelPresent = selection.getSecondLevel().length > 0;

        if ((!firstLevelPresent && !secondLevelPresent) || (firstLevelPresent && secondLevelPresent)) {
            //non-usable case of method
            return "";
        }
        return this.getCertainEntityList(selection, firstLevelPresent);
    }
});

export default HierarchySelectorSelectionHelper;


// WEBPACK FOOTER //
// ./web/js/controls/selectorControls/selectionHelpers/at_hierarchy_selector_selection_helper.js